import { _axios } from '../../plugins/axios'
import store from '../../store'
import MetricsController from './MetricsController'

class AvgNumberVisits extends MetricsController {
  value = {
    labels: [],
    datasets: [
      {
        label: 'Avg. Number of Visits',
        data: []
      }
    ]
  }

  getData () {
    const queryString = this.formatQueryParams()
    return _axios.get(`${store.getters['Organization/apiUrl']}/metrics/avgNumberVisits${queryString}`)
      .then((response) => {
        this.processTimeSeriesResponse(response)

        return this.value
      })
  }
}

export default new AvgNumberVisits()
